import { campaignBelowBrand, campaignCells, campaignHeaders, campaignViews, type CampaignDisplayRow, type CampaignReport } from "./campaignReport";

export type CampaignGridRow = Record<string,string|number|null>;
export type CampaignGridColumn = {
  key:string;label:string;minWidth?:number;flex?:number;align?:"left"|"right"|"center";
  sortType?:"number"|"date"|"text";band?:"label"|"context"|"current";wrap?:boolean;
  headerTooltip?:string;cellClassKey?:string;
};
export type CampaignGridProps = {
  columns:CampaignGridColumn[];rows:CampaignGridRow[];totalRow?:CampaignGridRow;
  compact:boolean;ariaLabel:string;totalRowPosition?:"top"|"bottom";pinnedColumns?:number;
  preserveGroups?:boolean;mobilePrimaryKeys?:string[];mobileMetricKeys?:string[];
};
const keys=["identity","scope","receipts","campaignReceipts","receiptRatio","units","campaignUnits","unitRatio","sales","campaignSales","salesRatio"];
const integer=new Intl.NumberFormat("tr-TR",{maximumFractionDigits:0});
const ratio=new Intl.NumberFormat("tr-TR",{maximumFractionDigits:2});
const dates=(value:string)=>value.split("-").reverse().join(".");

// Presentation adapter only. Measures, receipt eligibility, returns and scoped
// totals come directly from the existing, unchanged campaign report model.
export function campaignGridModel(report:CampaignReport,view:string,t:(text:string)=>string=(text)=>text){
  const views=campaignViews(report);
  const source:CampaignDisplayRow[]=view==="Genel Özet"?[
    ...report.daily.map(r=>({label:r.date,scope:"Günlük",measures:r.measures,kind:"detail" as const})),
    {label:"GENEL TOPLAM",scope:"",measures:report.totals,kind:"total"},
  ]:view==="Kampanya"?views.campaigns:view==="Marka"?views.brands:views.stores;
  const columns:CampaignGridColumn[]=campaignHeaders.map((label,c)=>({
    key:keys[c],label:t(c===0?(view==="Genel Özet"?"Tarih":view==="Kampanya"?"Kampanya Adı (OX)":label):c===1?(view==="Mağaza"?"Mağaza":view==="Kampanya"?"Kayıt Türü":"Kapsam"):label),
    minWidth:c===0?(view==="Kampanya"?310:120):c===1?(view==="Mağaza"?195:155):c===2||c===3?150:c>=8&&c<=9?140:105,
    flex:c===0&&view==="Kampanya"?2.4:c===1?1.5:1,
    align:c<2?"left":"right",sortType:c===0&&view==="Genel Özet"?"date":c<2?"text":"number",
    band:c<2?"label":[2,5,8].includes(c)?"context":"current",
    wrap:c===0&&view==="Kampanya",headerTooltip:t(label),
    cellClassKey:[4,7,10].includes(c)?`__class_${keys[c]}`:undefined,
  }));
  const toGrid=(r:CampaignDisplayRow,index:number):CampaignGridRow=>{
    const cells=campaignCells(r.label,r.scope,r.measures);
    const result:CampaignGridRow={__row_id:`${view}:${r.kind}:${r.label}:${r.scope}:${index}`,__kind:r.kind,
      __group:view==="Mağaza"?r.label.replace(/ TOPLAM$/,""):""};
    cells.forEach((value,c)=>{
      result[keys[c]]=typeof value==="number"?([4,7,10].includes(c)?`${ratio.format(value*100)}%`:integer.format(value)):value??"—";
      result[`__sort_${keys[c]}`]=value;
      if([4,7,10].includes(c))result[`__class_${keys[c]}`]=campaignBelowBrand(r,c)?"campaign-below-brand":"";
    });
    if(r.kind==="total")result.identity=t(r.label);
    if(r.kind==="subtotal"){
      result.identity=r.label.replace(/ TOPLAM$/,` ${t("TOPLAM")}`);
      result.scope=r.scope.replace(/ TOPLAM$/,` ${t("TOPLAM")}`);
    }else if(view!=="Mağaza")result.scope=t(r.scope);
    if(view==="Genel Özet"&&r.kind==="detail")result.identity=dates(r.label);
    return result;
  };
  return {columns,rows:source.filter(r=>r.kind!=="total").map(toGrid),
    totalRow:source.find(r=>r.kind==="total")?toGrid(source.find(r=>r.kind==="total")!,source.length):undefined};
}
